import type { FC } from "react";
import React from "react";
import type { FeatureFlagName } from "src/lib/featureFlags";
import { FeatureFlags } from "src/lib/featureFlags";
import { useBloc } from "src/state/state";
import { DebugToggleSwitch } from "./debug.styles";

const DebugFeatureFlags: FC = () => {
  const [, { toggle, getFlag }] = useBloc(FeatureFlags);

  const keyList = Object.keys(FeatureFlags.initialFlags) as FeatureFlagName[];

  return (
    <div>
      {keyList.map((key) => {
        const isEnabled = getFlag(key);
        return (
          <DebugToggleSwitch key={key}>
            <span className="label">{key}</span>
            <input
              type="checkbox"
              checked={isEnabled}
              onChange={() => toggle(key)}
            />
            <span className="switch" />
          </DebugToggleSwitch>
        );
      })}
    </div>
  );
};

export default DebugFeatureFlags;
